import { DQView } from './dq';

export function DQScreen() {
  return (
    <div className="h-full w-full overflow-y-auto p-4 md:p-6">
      <DQView />
    </div>
  );
}
